import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=4bf74095&"
import script from "./Center.vue?vue&type=script&lang=ts&"
export * from "./Center.vue?vue&type=script&lang=ts&"
import style0 from "./Center.vue?vue&type=style&index=0&id=4bf74095&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports